import { Navigate, useLocation } from "react-router-dom";

// The agents' pages lived under /learning-agents while the legacy fleet was still
// around; Slack messages and bookmarks still link there.
export const LearningAgentsRedirect = () => {
  const { pathname, search, hash } = useLocation();
  return (
    <Navigate
      to={{ pathname: pathname.replace(/^\/learning-agents/, "/agents"), search, hash }}
      replace
    />
  );
};
